<div mat-dialog-container>
  <div class="content">
    <!-- Dialog Header -->
    <div class="dialog-header">
      <span class="dialog-title">{{
        'SUPPORT-ICT.MAINTENANCE-SETTINGS' | translate
      }}</span>
      <button mat-icon-button class="close-button" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Conditional Introductory Text -->
    <div class="intro-text">
      @if (items.length > 0) {
        <p [innerHTML]="'SUPPORT-ICT.MAINTENANCE-DIALOG-TEXT' | translate"></p>
      }
      @if (items.length === 0) {
        <p>
          {{ 'SUPPORT-ICT.MAINTENANCE-DIALOG-NONE' | translate }}
        </p>
      }
    </div>

    <!-- Content Container with List, only if there are items -->
    @if (items.length > 0) {
      <div class="content-container">
        <ul>
          <!-- Display items with url === '/*' if showOnlyFullMaintenance is true -->
          @if (showOnlyFullMaintenance) {
            @for (item of items; track item) {
              @if (item.url === '/*') {
                <li>
                  {{ item.label }} -
                  <span>
                    {{
                      item.isDisabled
                        ? 'enable maintenance '
                        : 'disable maintenance '
                    }}
                    @if (item.isDisabled) {
                      <mat-icon
                        style="
                          color: green;
                          vertical-align: middle;
                          font-size: 20px;
                        ">
                        check_circle
                      </mat-icon>
                    }
                    @if (!item.isDisabled) {
                      <mat-icon
                        style="
                          color: red;
                          vertical-align: middle;
                          font-size: 20px;
                        ">
                        cancel
                      </mat-icon>
                    }
                  </span>
                </li>
              }
            }
          }
          <!-- Display all items if showOnlyFullMaintenance is false -->
          @if (!showOnlyFullMaintenance) {
            @for (item of items; track item) {
              <li>
                {{ item.label }} -
                <span>
                  {{
                    item.isDisabled
                      ? 'enable maintenance '
                      : 'disable maintenance '
                  }}
                  @if (item.isDisabled) {
                    <mat-icon
                      style="
                        color: green;
                        vertical-align: middle;
                        font-size: 20px;
                      ">
                      check_circle
                    </mat-icon>
                  }
                  @if (!item.isDisabled) {
                    <mat-icon
                      style="
                        color: red;
                        vertical-align: middle;
                        font-size: 20px;
                      ">
                      cancel
                    </mat-icon>
                  }
                </span>
              </li>
            }
          }
        </ul>
      </div>
    }

    @if (items.length > 0) {
      <div class="button-container">
        <button mat-raised-button color="accent" (click)="closeDialog()">
          {{ 'GENERAL.CANCEL' | translate }}
        </button>
        <!-- Save Button, only if there are items -->
        <button mat-raised-button class="mat-warn" (click)="save()">
          {{ 'GENERAL.SAVE' | translate }}
        </button>
      </div>
    }
  </div>
</div>
